import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class BranchDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      account: [],
      formData: {
        name: '',
        service_id: '',
        iban: '',
        bank_branch: '',
        account_no: '',
        branch_id: '',
      },
      loading: false,
      isLoad: true
    }
  }
  async componentDidMount() {
    this.getBankInfo();
    this.setState({ branches: await getBranches() })
  }
  getBankInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/settings/bank-account-detail/' + id, 'get', null);
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined ? "" : response[key]
      })
      this.setState({ formData: updatedData, isLoad: false }, () => { });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }))
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const id = this.props.match.params.id;
    const { formData } = this.state;
    const accountFormData = new FormData();
    Object.keys(formData).forEach(key => {
      accountFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/settings/update-bank-account/' + id, 'post', accountFormData);

      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const { formData, loading, branches } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateBranchPermission = userPermissions.includes('update branch');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Şube Detayı"
              Breadcrumb={[
                { name: "Banka Hesapları", navigate: "bank-accounts" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix justify-content-center">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body text-center">
                    <h6>Banka Hesabı Detayları</h6>
                    <div className="col-lg-12 d-flex justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        <label htmlFor="name" className="font-weight-bold text-cyan">
                          Banka Adı
                        </label>
                        <div className="form-group">
                          <input
                            name="name"
                            id='name'
                            value={formData.name}
                            className="form-control"
                            placeholder="Banka Adı"
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="bank_branch" className="font-weight-bold text-cyan">
                            Banka Şube
                          </label>
                          <input
                            name="bank_branch"
                            id='bank_branch'
                            value={formData.bank_branch}
                            className="form-control"
                            placeholder="Banka Şube"
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="account_no" className="font-weight-bold text-cyan">
                            Hesap No
                          </label>
                          <input
                            name="account_no"
                            id='account_no'
                            value={formData.account_no}
                            className="form-control"
                            placeholder="Hesap No"
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="iban" className="font-weight-bold text-cyan">
                            İban No
                          </label>
                          <input
                            name="iban"
                            id='iban'
                            value={formData.iban}
                            className="form-control"
                            placeholder="İban No"
                            onChange={this.handleChange}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                            Şube
                          </label>
                          <select name="branch_id" id='branch_id' className="form-control"
                            value={formData.branch_id}
                            onChange={this.handleChange}>
                            <option value="">Şube Seçiniz</option>
                            {branches && (branches.map(branch => (
                              <option key={branch.id} value={branch.id}>{branch.name}</option>
                            )))}

                          </select>
                        </div>

                        {loading ? (
                          <button
                            className="btn btn-outline-primary btn-lg btn-block"
                            disabled={true}
                            style={{ textAlign: "-webkit-center" }}
                          >
                            Lütfen Bekleyin... <ReactLoading type="spin" color="#268bd2" width={'24px'}
                              height={'24px'} />
                          </button>
                        ) : (
                          <button disabled={!userHasUpdateBranchPermission}
                            onClick={this.handleSubmit}
                            className="btn btn-outline-primary btn-lg btn-block"
                            type="submit"
                          >
                            Kaydet
                          </button>
                        )}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(BranchDetail)));
